import {DataTableCellProps} from "@variocube/app-ui";
import React from "react";
import {Booking} from "../../api";
import {LocationLinkChip} from "../location/LocationChip";

export function BookingLocationCell({row}: DataTableCellProps<Booking>) {
	return <LocationLinkChip location={row.location} />;
}
